define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

// add view security configuration

	

	var calendarAdminRoles = ['Calendar Administrator'];
	var calendarEditRoles = calendarAdminRoles.concat(['Calendar Editor']);
	var activityEditRoles = calendarEditRoles.concat(['Calendar Participant']);
	var calendarRoles = activityEditRoles.concat(['Calendar Viewer']);

	csiAccess.addViewRoles({
		"CalendarDescriptor":{
			"Calendar":{
				"":access(full(calendarAdminRoles), readOnly(calendarRoles))
			}
		},
		"CalendarContainer":{
			"Calendar":{
				"":access(full(calendarEditRoles), readOnly(calendarRoles))
			}
		},
		"MasterCalendarContainer":{
			"MasterCalendar":{
				"":access(full(calendarAdminRoles), readOnly(calendarRoles))
			}
		},
		"MasterCalendar":{
			"MasterActivities":{
				"":access(full(calendarEditRoles), readOnly(calendarRoles))
			}
		},
		"ProtoCalendar":{
			"ProtoActivityTable":{
				"":access(full(calendarAdminRoles), readOnly(calendarRoles))
			}
		}
	});
});